module.exports = "/images/fenix.png?934c823a10cbd1738a8e30c5fab55715";